module.exports = __webpack_public_path__ + "assets/img/img-vpp-what.1dda007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-vpp-what.png
// module id = 1065
// module chunks = 1